import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UndeleteProduct as UndeleteProductMutation,
    UndeleteProductVariables as UndeleteProductVariables,
    ProductUndeleteInput,
} from 'nutshell-graphql-types';

import UNDELETE_PRODUCT from '../mutations/undelete-product.graphql';
import GET_PRODUCTS from '../queries/get-products.graphql';

import {GET_PRODUCTS_LIMIT} from './use-get-products';

export const useUndeleteProduct = (): {
    undeleteProduct: (arg1: ProductUndeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [undeleteProduct, {loading, error}] = useMutation<
        UndeleteProductMutation,
        UndeleteProductVariables
    >(UNDELETE_PRODUCT);

    return {
        undeleteProduct: (input: ProductUndeleteInput) => {
            return undeleteProduct({
                variables: {input},
                update: (proxy, {data}) => {
                    const product = data && data.productUndelete && data.productUndelete.product;

                    if (!product) return;

                    const products = proxy.readQuery({
                        query: GET_PRODUCTS,
                        variables: {
                            first: GET_PRODUCTS_LIMIT,
                            archived: true,
                        },
                    });

                    if (!products) return;

                    // @ts-expect-error
                    const newEdges = products.products.edges.filter(
                        // @ts-expect-error
                        (node) => node.node.id !== product.id
                    );

                    proxy.writeQuery({
                        query: GET_PRODUCTS,
                        variables: {
                            first: GET_PRODUCTS_LIMIT,
                            archived: true,
                        },
                        data: {
                            products: {
                                edges: newEdges,
                                __typename: 'ProductsConnection',
                            },
                            __typename: 'Query',
                        },
                    });
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
